import styled from '@emotion/styled'
import { ExtranetNewsletterDto } from '@pharmac-extranet/extranet-api'
import {
  ExtranetListItem,
  ExtranetListItemProps,
  MediaQuery,
  formatDateString,
  htmlStringParser,
  useBreakpoint,
  useLanguage,
} from '@pharmac-extranet/shared'
import { PharmacBadge, PharmacContainer, PharmacText, PharmacTruncate } from '@pharmac/ui'
import { useNavigate } from 'react-router-dom'

type NewsletterProps = {
  newsletter: ExtranetNewsletterDto
}

const TopBarText = styled(PharmacText)`
  ${MediaQuery.maxMobile} {
    padding: var(--spacing-tiny) 0;
  }
`

const Badge = styled(PharmacBadge)`
  ${MediaQuery.maxMobile} {
    width: fit-content;
  }
`

const ContentText = styled(PharmacText)`
  max-height: 100%;
  overflow: hidden;
`

export const NewsletterListItem = ({ newsletter }: NewsletterProps) => {
  const { key } = useLanguage()
  const navigate = useNavigate()

  const { minDesktop, minTablet } = useBreakpoint()

  const hasRibbon = Object.values(newsletter.category.name).some(
    (a: string | null) => !!a && a.toLowerCase().includes('webina')
  )

  const itemProps: ExtranetListItemProps = {
    image: newsletter.image,
    title: PharmacTruncate(key(newsletter.title), 75),
    labels: [
      <>
        <TopBarText>{key(newsletter.category.name)}</TopBarText>
        <TopBarText
          marginSmallLeft
          marginSmallRight
        >
          {formatDateString(newsletter.newsletterDate)}
        </TopBarText>
        <PharmacContainer style={{ display: 'flex' }}>
          {newsletter.tags.map((a) => (
            <Badge
              key={a.id}
              small
              variant="primary"
              marginSmallRight
            >
              {key(a.name)}
            </Badge>
          ))}
        </PharmacContainer>
      </>,
    ],
    content: (
      <ContentText
        dangerouslySetInnerHTML={{
          __html: htmlStringParser(
            PharmacTruncate(key(newsletter.content), minDesktop ? 400 : minTablet ? 200 : 100) ?? ''
          ),
        }}
      />
    ),
    navigateFn: () => navigate(`${newsletter.id}`),
    ariaDescription: 'Link to newsletter',
    hasRibbon: hasRibbon,
    ribbonText: hasRibbon ? key(newsletter.category.name) : undefined,
  }

  return (
    <ExtranetListItem
      key={'newsletter-' + newsletter.id}
      {...itemProps}
    />
  )
}
